import { Input } from "../ui/input"
import { Button } from "../ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select"
import { Label } from "../ui/label"
import { RadioGroup, RadioGroupItem } from "../ui/radio-group"
import { Checkbox } from "../ui/checkbox"
import { Loader } from "lucide-react"
import { useState, useEffect } from "react"
import makeAnimated from "react-select/animated";
import { useOperador } from "../../../context/OperadorContext";
import { format } from "date-fns";
import moment from "moment";
import "moment-timezone";
import SelectMulti from "react-select";
import { useWhatsAppCampaign } from "../../../context/WhatsAppCampaignContext"

interface Processos {
  id_processo: string;
  label: string;
}

export default function FiltrosFilaCobranca() {

  const {
    assessorias,
    loadAssessorias,
    vendedores,
    filtros,
    data: infos,
    loadVendedores,
    loadData,
    setFiltros,
    setPage,
    page,
    classificacoes
  } = useOperador();
  const [loading, setLoading] = useState(false);
  const [assessoria, setAssessoria] = useState(filtros.assessoria ?? "all");
  const [processos, setProcessos] = useState<Processos[]>([]);
  const [processosOptions, setProcessosOptions] = useState([]);
  const [to, setTo] = useState(filtros.ate ?? 0);
  const [from, setFrom] = useState(filtros.de ?? 0);
  const [valueTo, setValueTo] = useState(filtros.valor_final ?? 0);
  const [valueFrom, setValueFrom] = useState(filtros.valor_inicial ?? 0);
  const [vendedor, setVendedor] = useState(filtros.vendedor ?? "all");
  const [classificacao, setClassificacao] = useState(filtros.classificacao ?? 'all')
  const [data, setData] = useState(filtros.data ?? "");
  const [agendamentos, setAgendamentos] = useState(
    filtros.agendamentos ?? "TODOS"
  );
  const [acionamentos, setAcionamentos] = useState(
    filtros.acionamentos === "sim" ? true : false
  );

  const animatedComponents = makeAnimated();
  const {
    selectClientsByCpf,
    setSkippedTodayClients
  } = useWhatsAppCampaign()

  function addOneDay(dateStr: string) {
    const date = new Date(dateStr);
    date.setDate(date.getDate());
    return date.toISOString().split("T")[0];
  }

  async function handleLoadWithFilters() {
    selectClientsByCpf([])
    setSkippedTodayClients([])
    let newDate = "";
    if (data !== "") {
      newDate = addOneDay(data);
    }
    // setPage(1);
    console.log(data ? newDate : undefined,)
    console.log("Data", data)
    const newProcessos = processos.map((processo) => processo.id_processo);
    setFiltros({
      page: page,
      assessoria: !assessoria || assessoria === "all" ? undefined : assessoria,
      de: from === 0 ? undefined : from,
      ate: to === 0 ? undefined : to,
      valor_inicial: valueFrom === 0 ? undefined : valueFrom,
      valor_final: valueTo === 0 ? undefined : valueTo,
      vendedor: !vendedor || vendedor === "all" ? undefined : vendedor,
      data: data ? newDate : undefined,
      agendamentos: agendamentos,
      acionamentos: acionamentos === true ? "SIM" : undefined,
      processos:
        processos.length > 0 ? JSON.stringify(newProcessos) : undefined,
      classificacao: classificacao
    });
    await loadData({
      page: page,
      assessoria: !assessoria || assessoria === "all" ? undefined : assessoria,
      de: from === 0 ? undefined : from,
      ate: to === 0 ? undefined : to,
      valor_inicial: valueFrom === 0 ? undefined : valueFrom,
      valor_final: valueTo === 0 ? undefined : valueTo,
      vendedor: !vendedor || vendedor === "all" ? undefined : vendedor,
      data: data ? newDate : undefined,
      agendamentos: agendamentos,
      acionamentos: acionamentos === true ? "SIM" : undefined,
      processos:
        processos.length > 0 ? JSON.stringify(newProcessos) : undefined,
      classificacao: classificacao,
      data_producao: moment(new Date())
        .tz("America/Sao_Paulo")
        .format("YYYY-MM-DD")
    });
  }

  function clearFilters() {
    setAssessoria("all");
    setProcessos([]);
    setTo(0);
    setFrom(0);
    setValueTo(0);
    setValueFrom(0);
    setVendedor("all");
    setData("");
    setAgendamentos("TODOS");
    setAcionamentos(false);
    setClassificacao('all')
    selectClientsByCpf([])
    setSkippedTodayClients([])
  }
  async function clearAndReload() {
    setLoading(true);
    clearFilters();
    setPage(0)
    setFiltros({
      page: 0,
    });
    await loadData({
      page: 0,
      data_producao: moment(new Date())
        .tz("America/Sao_Paulo")
        .format("YYYY-MM-DD")
    });
    setLoading(false);
  }
  useEffect(() => {
    const processos = infos?.data.map((inf) => {
      return {
        id_processo: inf.id_processo,
        value: inf.id_processo,
        label: `${inf.id_processo} - ${inf.processo}`,
      };
    });
    const newProcessos =
      processos?.reduce(
        (
          unique: Array<{ value: string; label: string }>,
          current: { value: string; label: string }
        ) => {
          const exist = unique.findIndex(
            (item: { value: string; label: string }) =>
              item.value === current.value
          );
          if (exist === -1) {
            unique.push(current);
          }
          return unique;
        },
        []
      ) ?? [];
    setProcessosOptions(newProcessos as []);
  }, [infos]);

  useEffect(() => {
    setLoading(true);
    loadAssessorias();
    loadVendedores();
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    handleLoadWithFilters();
    setLoading(false);
  }, []);


  return (
    <div className="w-full bg-white rounded-lg border border-gray-200 p-4">
      <div className="grid grid-cols-6 gap-4 mb-4 w-full" >
        {/* Assessoria */}
        <div className="">
          <Label className="text-xs text-gray-600 mb-1 block">Assessoria</Label>
          <Select
            defaultValue="todas"
            value={assessoria}
            onValueChange={(value) => setAssessoria(value)}

          >
            <SelectTrigger className="h-9 w-full">
              <SelectValue placeholder="Todas" />
            </SelectTrigger>
            <SelectContent className="w-full">
              {!assessorias || assessorias.length < 1 || loading ? (
                <Loader />
              ) : (
                <>

                  {assessorias?.map((assessoria) => (
                    <SelectItem value={assessoria.assessoria}>
                      {assessoria.assessoria}
                    </SelectItem>
                  ))}
                </>
              )}

            </SelectContent>
          </Select>
        </div>

        {/* Dias em atraso */}
        <div>
          <Label className="text-xs text-gray-600 mb-1 block">Dias em atraso</Label>
          <div className="flex gap-2">
            <div className="flex items-center gap-1">
              <span className="text-xs text-gray-500">De:</span>
              <Input type="number"
                defaultValue="0"
                className="h-9 w-16"
                min={0}
                value={from}
                onChange={(e) => setFrom(Number(e.target.value))}
              />
            </div>
            <div className="flex items-center gap-1">
              <span className="text-xs text-gray-500">Até:</span>
              <Input
                type="number"
                defaultValue="0"
                className="h-9 w-16"
                min={0}
                value={to}
                onChange={(e) => setTo(Number(e.target.value))} />
            </div>
          </div>
        </div>

        {/* Vendedor */}
        {/* <div>
          <Label className="text-xs text-gray-600 mb-1 block">Vendedor</Label>
          <Select
            defaultValue="todos"
            value={vendedor}
            onValueChange={(value) => setVendedor(value)}
          >
            <SelectTrigger className="h-9 w-full">
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              {!vendedores || vendedores.length < 1 || loading ? (
                <Loader />
              ) : (
                <>
                  {vendedores?.map((vendedor) => (
                    <SelectItem value={vendedor.nome_vendedor}>
                      {vendedor.nome_vendedor}
                    </SelectItem>
                  ))}
                </>
              )}

            </SelectContent>
          </Select>
        </div> */}

        <div className="flex flex-col ">
          <Label className="text-xs text-gray-600  mb-1 block" htmlFor="vendedor">Vendedor</Label>

          <select
            id="vendedor"
            className="w-full  p-2 border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 h-9"
            value={vendedor}
            onChange={(e) => setVendedor(e.target.value)}
          >
            <option value="all">Todos</option>
            {!vendedores || vendedores.length < 1 || loading ? (
              <Loader />
            ) : (
              <>
                {vendedores?.map((vendedor) => (
                  <option value={vendedor.nome_vendedor}>
                    {vendedor.nome_vendedor}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>

        {/* Último acionamento */}
        <div>
          <Label className="text-xs text-gray-600 mb-1 block">Último acionamento</Label>
          <Input
            type="date"
            className="h-9"
            placeholder="dd/mm/aaaa"
            value={data}
            onChange={(e) => setData(e.target.value)}
            max={format(new Date(), 'yyyy-MM-dd')} />
        </div>

        {/* Último Envio WhatsApp */}
        {/* <div>
          <Label className="text-xs text-gray-600 mb-1 block">Último Envio WhatsApp</Label>
          <Input
            type="date"
            className="h-9"
            placeholder="dd/mm/aaaa"
            value={data}
            onChange={(e) => setData(e.target.value)}
            max={format(new Date(), 'yyyy-MM-dd')} />
        </div> */}

        {/* Tem agendamentos? */}
        <div>
          <Label className="text-xs text-gray-600 mb-1 block">Tem agendamentos?</Label>
          <RadioGroup defaultValue="TODOS" className="flex "
            value={agendamentos}
            onValueChange={setAgendamentos}
          >
            <div className="flex items-center space-x-1">
              <RadioGroupItem value="TODOS" id="todos" />
              <Label htmlFor="todos" className="text-xs">
                Todos
              </Label>
            </div>
            <div className="flex items-center space-x-1">
              <RadioGroupItem value="SIM" id="sim" />
              <Label htmlFor="sim" className="text-xs">
                Sim
              </Label>
            </div>
            <div className="flex items-center space-x-1">
              <RadioGroupItem value="NAO" id="nao" />
              <Label htmlFor="nao" className="text-xs">
                Não
              </Label>
            </div>
          </RadioGroup>
        </div>
      </div>

      <div className="grid grid-cols-[170px_600px_1fr_1fr_1fr_1fr] gap-4 items-end">
        {/* Valor vencido */}
        <div>
          <Label className="text-xs text-gray-600 mb-1 block">Valor vencido</Label>
          <div className="flex gap-2">
            <div className="flex items-center gap-1">
              <span className="text-xs text-gray-500">De:</span>
              <Input
                type="number"
                defaultValue="0"
                className="h-9 w-16"
                min={0}
                value={valueFrom}
                onChange={(e) => setValueFrom(Number(e.target.value))} />
            </div>
            <div className="flex items-center gap-1">
              <span className="text-xs text-gray-500">Até:</span>
              <Input
                type="number"
                defaultValue="0"
                className="h-9 w-16"
                min={0}
                value={valueTo}
                onChange={(e) => setValueTo(Number(e.target.value))} />
            </div>
          </div>
        </div>

        {/* Processos */}


        <div className="ml-1 flex w-[100%] flex-col ">
          <Label className="text-xs text-gray-600 mb-1 block">Processos</Label>
          <SelectMulti
            closeMenuOnSelect={false}
            components={animatedComponents}
            isMulti
            value={processos}
            onChange={(e) => setProcessos(e as [])}
            options={processosOptions}
          />
        </div>

        {/* Classificação */}
        <div>
          <Label className="text-xs text-gray-600 mb-1 block">Classificação</Label>
          <Select defaultValue="todos" value={classificacao}
            onValueChange={(value) => setClassificacao(value)}>
            <SelectTrigger className="h-9 w-full">
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              {!classificacoes || classificacoes.length < 1 || loading ? (
                <Loader />
              ) : (
                <>
                  {classificacoes?.map((classi) => (
                    <SelectItem value={classi}>
                      {classi}
                    </SelectItem>
                  ))}
                </>
              )}

            </SelectContent>
          </Select>
        </div>

        {/* Limite Fila */}
        {/*   <div>
          <Label className="text-xs text-gray-600 mb-1 block">Limite Fila</Label>
          <Input className="h-9" id="limite" value={data}
            onChange={(e) => setData(e.target.value)} />
        </div>*/}
        {/* WhatsApp checkbox */}
        {/* <div className="mt-2 flex items-end">
          <Checkbox
            id="clientes-sem"
            checked={whatsapp}
            onCheckedChange={(value) => setWhatsApp(!!value)}
            className="h-5 w-5 "
          />

          <Label htmlFor="clientes-sem" className="text-xs ml-2">
          Sem Envio WhatsAAp
          </Label>
        </div> */}


        {/* Acionamentos checkbox */}
        <div className="mt-2 flex items-end">
          <Checkbox
            id="clientes-sem"
            checked={acionamentos}
            onCheckedChange={(value) => setAcionamentos(!!value)}
            className="h-5 w-5 "
          />

          <Label htmlFor="clientes-sem" className="text-xs ml-2">
            Clientes sem acionamento
          </Label>
        </div>

        {/* Buttons */}
        <div className="flex gap-2">
          <Button variant="outline" className="h-9 bg-transparent" onClick={clearAndReload}>
            Limpar
          </Button>
          <Button className="h-9 bg-blue-600 hover:bg-blue-700 text-white" onClick={() => {
            setPage(1);
            handleLoadWithFilters()
          }}>Filtrar</Button>
        </div>
      </div>
    </div>
  )
}
